import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { loginService } from "../services/login";
import HeaderPublic from "./HeaderPublic";
import FooterPublic from "./FooterPublic";
import { useAuth } from "../contexts/AuthContext";
import "./Login.css";

const Login = () => {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const { executeRecaptcha } = useGoogleReCaptcha();

  /* -------------------------------------------------
     Handle input
  ------------------------------------------------- */
  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  /* -------------------------------------------------
     Handle login
  ------------------------------------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      if (!executeRecaptcha) {
        setError("reCAPTCHA not ready. Please try again.");
        setLoading(false);
        return;
      }

      const recaptchaToken = await executeRecaptcha("login");

      const data = await loginService.login(
        credentials.email,
        credentials.password,
        recaptchaToken
      );

      if (data?.token && data?.user) {
        const normalizedUser = {
          ...data.user,
          channels: Array.isArray(data.user.channels)
            ? data.user.channels
            : [],
          favchannels: Array.isArray(data.user.favchannels)
            ? data.user.favchannels
            : [],
        };

        // 🔥 AUTH SET
        login(normalizedUser);

        // Back to the page that sent them to log in, if there was one — a
        // shared link opened while signed out — otherwise the channel list.
        const from = location.state?.from;
        const target =
          from?.pathname && !["/", "/login"].includes(from.pathname)
            ? `${from.pathname}${from.search || ""}`
            : "/home";

        navigate(target, { replace: true });

      } else {
        setError("Invalid credentials");
      }
    } catch (err) {
      setError(err.message || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  /* -------------------------------------------------
     Render
  ------------------------------------------------- */
  return (
    <>
      <HeaderPublic />

      <div className="login-page">
        <div className="login-container">
          <div className="login-box">
            <div className="login-logo">
              <img
                src="/mongrel-logo.png"
                alt="mongrel"
                className="logo-img"
              />
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              {error && <div className="error-msg">{error}</div>}

              <label htmlFor="email">Username</label>
              <input
                id="email"
                type="email"
                name="email"
                value={credentials.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />

              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />

              <button type="submit" disabled={loading}>
                {loading ? "Signing in..." : "SUBMIT"}
              </button>

              <Link to="/forgot-password" className="login-forgot">
                Forgot your password?
              </Link>
            </form>
          </div>
        </div>
      </div>

      <FooterPublic />
    </>
  );
};

export default Login;